<template>
  <div class="container" v-if="assignment">
    <div class="header">
      <div class="headerContent">
        <div class="breadcrumbs">
          <div class="text">Private Pilot 2025</div>
          <div>|</div>
          <div class="text">Pilot Qualifications</div>
          <div>|</div>
          <b class="pageTitle">{{ assignment.name }}</b>
        </div>
<!--        <button class="historyReportParent" @click="toggleAdminAssignmentHistoryRep">
          <span class="historyReport">History Report</span>
        </button>-->
      </div>
      <div class="backButton" @click="navigateBack">
        <img class="backIcon" alt="" src="/static/img/LeftChevron.svg" />
      </div>
    </div>
    <div class="quizOverviewContainer">
      <div class="quizOverview">
        <div class="totalScoreParent">
          <div class="totalScoreContainer text-center">
            <span>
              <b>Score</b>
              <span class="span"> - </span>
            </span>
            <b class="b">{{ percentage }}%</b>
          </div>
          <div class="correct2Container text-center">
            <b>Correct</b>
            <span class="span1"> - {{correctQuestions}}</span>
          </div>
          <div class="incorrect1Container text-center">
            <b>Incorrect</b>
            <span class="span1"> - {{incorrectQuestions}}</span>
          </div>
        </div>
        <div>
          <b class="quizTitle">{{ assignment.name }}</b>
          <div class="quizObjective">
            {{ assignment.description }}
          </div>
        </div>
      </div>
    </div>
    <div class="questionContainer" v-for="(question, index) in assignment.questions" :key="question.id">
      <b class="questionNumber">Question {{ index + 1 }}</b>
      <div class="question">
        {{ question.question }}
      </div>
      <div class="frameParent2" v-if="getQuestionType(question, 'Multiple Choice', index)">
        <div v-for="(choice, answerIndex) in question.questionChoices" :key="answerIndex" class="answerContainer" :class="checkIfSelected(choice)">
          <label :for="`answer-${answerIndex}`" class="text">{{ choice.description }}</label>
          <input type="radio" :id="`answer-${answerIndex}`" v-model="form[question.id]" :value="choice.id" disabled />
        </div>
        <div class="points">
          {{question.studentPoints}}/{{question.possiblePoints}}
        </div>
      </div>
      <div class="frameParent2" v-else-if="getQuestionType(question, 'Short Answer', index)">
        <div class="answerWrapper">
          <div class="answer" v-if="gradeView">
          </div>
          <div v-else>
            <textarea
              class="textArea"
              placeholder="Type your answer here..."
              v-model="form[question.id]"
               disabled
            ></textarea>
          </div>
        </div>
      </div>
      <div class="frameParent2" v-else-if="getQuestionType(question, 'Select All That Apply', index)">
        <div v-for="(choice, answerIndex) in question.questionChoices" :key="answerIndex" class="answerContainer" :class="checkIfSelected(choice)">
          <input type="checkbox" :id="`select-all-${question.id}-${answerIndex}`" :checked="form[question.id].includes(choice.id)" @change="(e) => handleSelect(e, question.id, choice.id)" disabled />
          <label :for="`select-all-${question.id}-${answerIndex}`" class="text">{{ choice.description }}</label>
        </div>
        <div class="points">
          {{question.studentPoints}}/{{question.possiblePoints}}
        </div>
      </div>
      <div class="matchingContainer" v-else-if="getQuestionType(question, 'Matching', index)">
        <div class="matchingChoiceContainer" v-for="choice of question.questionChoices" v-bind:key="choice.id">
          <div class="column1Matching" :class="choice.id === form[question.id][choice.id] ? 'correctAnswer' : 'incorrectAnswer'">
            {{choice.description}}
          </div>
          <div class="column1Matching" :class="choice.id === form[question.id][choice.id] ? 'correctAnswer' : 'incorrectAnswer'">
            {{question.questionChoices.find(data => data.id === form[question.id][choice.id]).matchingString}}
          </div>
        </div>
        <div class="points">
          {{question.studentPoints}}/{{question.possiblePoints}}
        </div>
      </div>
      <br />
      <div class="aiResponse" v-if="aiResponses && aiResponses[assignment.questions.indexOf(question)]">
        <img class="vectorIcon" alt="" src="/static/img/Sparkling.svg" />
        <div class="theCorrectAnswerContainer">
          <p class="theCorrectAnswer17Year">
            <span class="yearsOfAge">
              <b class="theCorrectAnswer">The correct answer</b>
              <span class="yearsOfAge">
                -
                {{
                  aiResponses[assignment.questions.indexOf(question)].correctAnswer.description
                    ? aiResponses[assignment.questions.indexOf(question)].correctAnswer.description
                    : aiResponses[assignment.questions.indexOf(question)].correctAnswer
                }}
              </span>
            </span>
          <ol v-if="aiResponses[assignment.questions.indexOf(question)].correctAnswer.list">
            <li v-for="item of aiResponses[assignment.questions.indexOf(question)].correctAnswer.list" v-bind:key="item">{{ item }}
            </li>
          </ol>
          </p>
          <p class="theCorrectAnswer17Year">
            <span class="yearsOfAge">
              <span class="yearsOfAge">&nbsp;</span>
            </span>
          </p>
          <p class="theCorrectAnswer17Year">
            <span class="yearsOfAge">
              <span class="yearsOfAge">Why This is the Right Answer:</span>
            </span>
          </p>
          <ol class="regulatoryRequirementTheFa">
            <li class="trainingAgeVsCertification" v-for="item of aiResponses[assignment.questions.indexOf(question)].why"
              v-bind:key="item.header">
              <span class="yearsOfAge">
                <b class="theCorrectAnswer">{{ item.header }}: </b>
                <span>{{ item.description }}</span>
              </span>
            </li>
          </ol>
          <p class="theCorrectAnswer17Year">
            <span class="yearsOfAge">
              <span class="yearsOfAge">&nbsp;</span>
            </span>
          </p>
          <p class="theCorrectAnswer17Year">
            <span class="yearsOfAge">
              <span class="yearsOfAge">{{
                aiResponses[assignment.questions.indexOf(question)].footer.description
              }}
              </span>
            </span>
            <span class="yearsOfAge">
              <span class="cfr611031">{{
                aiResponses[assignment.questions.indexOf(question)].footer.link
              }}</span>
            </span>
          </p>
          <p class="theCorrectAnswer17Year">
            <span class="yearsOfAge">
              <span>&nbsp;</span>
            </span>
          </p>
        </div>
      </div>
    </div>
<!--    <assignment-history-report-pop-up :is-visible="historyReportOpen"
      @close="toggleAdminAssignmentHistoryRep"></assignment-history-report-pop-up>-->
  </div>
</template>
<script>
import AssignmentHistoryReportPopUp from "./AssignmentHistoryReportPopUp.vue";
import AssignmentsAPIService from "../../../../servicehandlers/AssignmentsAPIService.js";
const assignmentService = new AssignmentsAPIService();

import { useLoginStore } from "@/stores/loginStore";

export default {
  components: {
    //AssignmentHistoryReportPopUp
  },
  data() {
    return {
      gradeView: false,
      studentId: null,
      assignmentId: null,
      assignment: {},
      aiResponses: [],
      historyReportOpen: false,
      form: {},
      percentage: 0,
      correctQuestions: 0,
      incorrectQuestions: 0,
    };
  },
  async mounted() {
    this.assignmentId = this.$route.query.assignmentId;
    if (this.$route.query.studentId){
      this.studentId = this.$route.query.studentId
    } else {
      this.studentId = useLoginStore().getUser.id
    }

    this.getAssignment()
  },
  methods: {
    getAssignment(){
      return assignmentService.getGradedAssignmentForStudent(this.studentId, this.assignmentId, this.$router)
        .then(response => {
          this.assignment = response.assignment
          this.percentage = response.gradePercentage
          this.studentAnswers = response.studentAnswers

          for (let question of this.assignment.questions){
            switch (question.questionType.name){
              case 'Multiple Choice':
                let correctAnswer = question.questionChoices[0]
                for (let choice of question.questionChoices){
                  if (choice.pointValue > correctAnswer.pointValue){
                    correctAnswer = choice
                  }
                  if (this.studentAnswers.some(data => data.studentAnswerChoiceId === choice.id)){
                    this.form[question.id] = choice.id
                  }
                }

                let studentAnswer = this.studentAnswers.find(data => data.questionId === question.id)
                question.studentPoints = studentAnswer.questionChoice.pointValue
                question.possiblePoints = correctAnswer.pointValue

                if (this.studentAnswers.some(data => data.studentAnswerChoiceId === correctAnswer.id)){
                  this.correctQuestions++
                } else {
                  this.incorrectQuestions++
                }
                break
              case 'Select All That Apply':
                let correctAnswers = []
                this.form[question.id] = []
                for (let choice of question.questionChoices){
                  if (choice.pointValue > 0){
                    correctAnswers.push(choice)
                  }
                  if (this.studentAnswers.some(data => data.studentAnswerChoiceId === choice.id)){
                    this.form[question.id].push(choice.id)
                  }
                }
                let correctAnswerIds = correctAnswers.map(data => data.id)
                let studentAnswers = this.studentAnswers
                  .filter(data => data.questionId === question.id)
                  .map(data => data.questionChoice);

                question.possiblePoints = 0
                question.studentPoints = 0
                for (let choice of correctAnswers){
                  question.possiblePoints += parseFloat(choice.pointValue)
                }
                for (let answer of studentAnswers){
                  question.studentPoints += parseFloat(answer.pointValue)
                }

                if (equals(correctAnswerIds, studentAnswers.map(data => data.id))){
                  question.studentPoints = question.possiblePoints
                  this.correctQuestions++
                } else {
                  this.incorrectQuestions++
                }

                break
              case 'Matching':
                this.form[question.id] = {}
                let correct = true
                question.possiblePoints = 0
                question.studentPoints = 0
                for (let choice of question.questionChoices){
                  if (parseFloat(choice.pointValue) > 0){
                    question.possiblePoints += parseFloat(choice.pointValue)
                  }
                  let studentAnswer = this.studentAnswers.find(data => data.studentAnswerChoiceId === choice.id)
                  this.form[question.id][choice.id] = studentAnswer.studentMatchingChoiceId
                  if (studentAnswer.studentAnswerChoiceId !== studentAnswer.studentMatchingChoiceId){
                    correct = false
                  } else {
                    question.studentPoints += parseFloat(choice.pointValue)
                  }
                }
                if (correct){
                  this.correctQuestions++
                } else {
                  this.incorrectQuestions++
                }
                break
            }
          }

          if (!this.assignment.graded){
            this.correctQuestions = 0
            this.incorrectQuestions = 0
          }

          function equals(arr1, arr2) {
            if (arr1.length !== arr2.length) return false;

            const sorted1 = arr1.slice().sort((a, b) => a - b);
            const sorted2 = arr2.slice().sort((a, b) => a - b);

            return sorted1.every((value, index) => value === sorted2[index]);
          }
        })
    },
    handleSelect(event, questionId, choiceValue) {
      if(!this.form[questionId])
        this.form[questionId] = [];

      if(event.target.checked) {
        this.form[questionId].push(choiceValue);
      } else {
        this.form[questionId] = this.form[questionId].filter((item) => {
          return item !== choiceValue;
        });
      }

      this.$forceUpdate();
    },
    getQuestionType(obj, qType, qIndex) {
      return obj.questionType.name === qType;
    },
    toggleAdminAssignmentHistoryRep() {
      this.historyReportOpen = !this.historyReportOpen
    },
    navigateBack() {
      if (this.$route.query.fromTake){
        this.$router.go(-2);
      } else {
        this.$router.go(-1);
      }
    },
    checkIfSelected(choice){
      let question = this.assignment.questions.find(data => data.id === choice.questionId)
      let classString = ''
      if (this.assignment.graded) {
        if (this.studentAnswers.some(data => data.studentAnswerChoiceId === choice.id)) {
          classString += 'selected'


          switch (question.questionType.name) {
            case 'Multiple Choice':
              let maxChoice = question.questionChoices[0]
              for (let possibleChoice of question.questionChoices) {
                if (possibleChoice.pointValue > maxChoice.pointValue) {
                  maxChoice = possibleChoice
                }
              }
              if (choice.id === maxChoice.id) {
                classString += ' correctAnswer'
              }
              break
            case 'Select All That Apply':
              let possibleChoices = []
              for (let possibleChoice of question.questionChoices) {
                if (possibleChoice.pointValue > 0) {
                  possibleChoices.push(possibleChoice.id)
                }
              }
              if (possibleChoices.includes(choice.id)) {
                classString += ' correctAnswer'
              }
          }
        }

        if (classString === 'selected') {
          classString += ' incorrectAnswer'
        }

        if (question.questionType.name === 'Select All That Apply' && choice.pointValue > 0 && classString === '') {
          classString += 'incorrectAnswer'
        }
      }
      return classString
    },
  },
};
</script>
<style scoped>
.points{
  position: absolute;
  top: 0;
  right: 0;
  margin: 75px 150px;
}
.textArea {
  border: none;
  width: 100%;
  resize: none;
  outline: none;
}
.historyReport {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.historyReportParent {
  position: absolute;
  right: 0;
  border-radius: 5px;
  background-color: #f6f6f6;
  border: 1px solid #c3c3c3;
  box-sizing: border-box;
  /*width: 100%;
  height: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 20px;
  cursor: pointer;
  text-align: center;
  font-size: 15px;
  color: #000;
  font-family: Helvetica, Arial, sans-serif;*/
}

.text {
  position: relative;
}

.pageTitle {
  position: relative;
  color: #404040;
}

.breadcrumbs {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.headerContent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  z-index: 0;
  position: relative;
}

.backIcon {
  width: 16px;
  position: relative;
  height: 16px;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: contain;
  cursor: pointer;
}

.backButton {
  margin: 0 !important;
  position: absolute;
  top: 2px;
  left: 0;
  background-color: #f6f6f6;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 20px;
  z-index: 1;
}

.header {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 50px;
  position: relative;
  gap: 20px;
  z-index: 6;
  font-size: 25px;
  color: rgba(64, 64, 64, 0.5);
}

.quizObjective {
  align-self: stretch;
  position: relative;
  font-size: 18px;
}

.quizOverview {
  width: 900px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 75px 150px;
  box-sizing: border-box;
  gap: 30px;
}

.quizOverviewContainer {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0 50px;
  z-index: 5;
  font-size: 45px;
}

.questionNumber {
  align-self: stretch;
  position: relative;
  font-size: 22px;
}

.question {
  align-self: stretch;
  position: relative;
}

.answerContainer {
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  padding: 10px 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  height: 100%;
  /* box-sizing: border-box;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between; */
}
.answerContainer input {
  position: absolute;
  right: 20px;
  width: 12px;
}
.answerContainer label {
  margin: 0;
  font-size: 16px;
}

.correctAnswer {
  background-color: #c9f8e0;
  border: 1px solid #0c974f;
}

.incorrectAnswer {
  background-color: #fabdbd;
  border: 1px solid #c24e4e;
}

.ellipseDiv {
  width: 15px;
  position: relative;
  border-radius: 50%;
  border: 1px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 15px;
}

.frameParent2 {
  width: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}

.questionContainer {
  width: 900px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  height: auto;
  overflow-y: visible;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 75px 150px;
  box-sizing: border-box;
  gap: 30px;
  z-index: 4;
  position: relative;
}

.quizTitle {
  align-self: stretch;
  position: relative;
}

.answer {
  flex: 1;
  position: relative;
}

.answerWrapper {
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  /* box-sizing: border-box;
  height: 150px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start; */
  padding: 20px;
  width: 100%;
}

.column1Matching {
  align-self: stretch;
  flex: 1;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 20px;
}

.column2Matching {
  flex: 1;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 103px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.matchingChoiceContainer {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.matchingContainer {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}

.submitWrapper {
  flex: 1;
  border-radius: 10px;
  background-color: #3c78ff;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.submitContainer {
  width: 900px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  cursor: pointer;
  z-index: 1;
  color: #fff;
}

.container {
  height: 100%;
  flex: 1;
  width: 100%;
  position: relative;
  background-color: #f6f6f6;
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 50px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
  margin-bottom: 50px;
}

.span {
  font-family: Helvetica, Arial, sans-serif;
}

.b {
  color: #f56e08;
}

.totalScoreContainer {
  align-self: stretch;
  width: 186.7px;
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}

.span1 {
  color: #404040;
}

.correct2Container {
  align-self: stretch;
  flex: 1;
  position: relative;
  color: #0c974f;
}

.incorrect1Container {
  align-self: stretch;
  flex: 1;
  position: relative;
  color: #ba0000;
}

.totalScoreParent {
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
  gap: 10px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}

.vectorIcon {
  width: 24px;
  position: relative;
  height: 23px;
}

.theCorrectAnswer {
  font-family: Helvetica, Arial, sans-serif;
}

.yearsOfAge {
  white-space: pre-wrap;
}

.theCorrectAnswer17Year {
  margin: 0;
}

.trainingAgeVsCertification {
  margin-bottom: 0px;
}

.regulatoryRequirementTheFa {
  margin: 0;
  font-size: inherit;
  padding-left: 24px;
}

.cfr611031 {
  color: rgba(8, 0, 255, 0.6);
}

.theCorrectAnswerContainer {
  align-self: stretch;
  width: 600px;
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}

.aiResponse {
  position: relative;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
  gap: 10px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
</style>
